import React, { Fragment } from "react";
import styles from "./AnimatedHero.module.css";

const AnimatedHero = (props) => {
  return (
    <Fragment>
      <div className={styles.background}>
        <div className={styles.blured}></div>
        <div className={styles.bubbles}>
          <span style={{ "--i": "11" }}></span>
          <span style={{ "--i": "14" }}></span>
          <span style={{ "--i": "23" }}></span>
          <span style={{ "--i": "10" }}></span>
          <span style={{ "--i": "16" }}></span>
          <span style={{ "--i": "13" }}></span>
          <span style={{ "--i": "23" }}></span>
          <span style={{ "--i": "10" }}></span>
          <span style={{ "--i": "14" }}></span>
          <span style={{ "--i": "10" }}></span>
          <span style={{ "--i": "19" }}></span>
          <span style={{ "--i": "14" }}></span>
          <span style={{ "--i": "21" }}></span>
          <span style={{ "--i": "20" }}></span>
          <span style={{ "--i": "10" }}></span>
          <span style={{ "--i": "15" }}></span>
          <span style={{ "--i": "23" }}></span>
          <span style={{ "--i": "11" }}></span>
          <span style={{ "--i": "23" }}></span>
          <span style={{ "--i": "12" }}></span>
          <span style={{ "--i": "10" }}></span>
          <span style={{ "--i": "14" }}></span>
          <span style={{ "--i": "16" }}></span>
          <span style={{ "--i": "13" }}></span>
          <span style={{ "--i": "14" }}></span>
          <span style={{ "--i": "25" }}></span>
          <span style={{ "--i": "16" }}></span>
          <span style={{ "--i": "19" }}></span>
          <span style={{ "--i": "14" }}></span>
          <span style={{ "--i": "10" }}></span>
          <span style={{ "--i": "15" }}></span>
          <span style={{ "--i": "23" }}></span>
          <span style={{ "--i": "12" }}></span>
        </div>
      </div>
    </Fragment>
  );
};

export default AnimatedHero;
